import React from "react"
import Button from "@material-ui/core/Button"
import Typography from "@material-ui/core/Typography"
import { useCalendarToolStyle } from "./style"
import TimePicker from "Views/OpLog/TimePicker"
import { useCalendarTool } from "./hook"

export default () => {
    const classes = useCalendarToolStyle()
    const { handleCreate, setData, disabled } = useCalendarTool()
    return (
        <div className={classes.root}>
            <div className={classes.timePicker}>
                <Typography>请选择生成时间:&nbsp;&nbsp;&nbsp;</Typography>
                <TimePicker minDate={new Date()} onSearch={(value) => {
                    const { updated_at } = value
                    const { _gte, _lte } = updated_at
                    setData({
                        start_at: _gte,
                        end_at: _lte,
                    })
                }}/>
            </div>
            <Button
                color="primary"
                variant="contained"
                disabled={disabled}
                onClick={handleCreate}
            >
                生成到微信日历
            </Button>
        </div>
    )
}

